import React, { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MapView } from '@/components/MapView';
import { Toaster } from '@/components/ui/sonner';

const Home = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      <MapView />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
